<template>
  <div class="ak-form-group__addon">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-field-addon>
   *   <ak-icon type="fireball" />
   * </ak-field>
   */
  name: 'AkFieldAddon',
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-form-group__addon {
  background-color: $color-grey-lightest;
  padding-left: $spacing-small;
  padding-right: $spacing-small;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $border-input-color;
}
</style>
